export default {
    list: {
        title: 'Address Book',
        subtitle: 'Manage your contacts',
        addContact: 'Add Contact',
        loading: 'Loading contacts...',
        allRoles: 'All roles',
        searchPlaceholder: 'Search by name, surname or email...',
        rolePlaceholder: 'Filter by role',
        description: 'List of contacts in your address book',
        headers: {
            firstName: 'First Name',
            lastName: 'Last Name',
            company: 'Company',
            email: 'Email',
            phone: 'Phone',
            role: 'Role',
            actions: 'Actions',
        },
        noContacts: {
            title: 'No contacts found',
            message: 'Try modifying the search filters',
            emptyMessage: 'Start by adding your first contact',
            addFirst: 'Add First Contact',
            companyTitle: 'No contacts found',
            companyMessage: 'Currently there are no people associated to this company',
            clearFilter: 'Clear Filter',
        },
        modal: {
            addTitle: 'Add Contact',
            editTitle: 'Edit Contact',
            fields: {
                firstName: 'First Name',
                firstNamePlaceholder: 'Enter first name',
                lastName: 'Last Name',
                lastNamePlaceholder: 'Enter last name',
                company: 'Company',
                companyPlaceholder: 'Enter company name',
                email: 'Email',
                emailPlaceholder: 'name@company.com',
                phone: 'Phone',
                phonePlaceholder: 'Enter phone number',
                role: 'Role',
                notes: 'Notes',
                notesPlaceholder: 'Add any additional notes about this contact...',
            },
            cancel: 'Cancel',
            save: 'Save Changes',
            create: 'Add Contact',
        },
        confirmDelete: {
            title: 'Confirm deletion',
            message: 'Are you sure you want to delete this contact? This action cannot be undone.',
            cancel: 'Cancel',
            delete: 'Delete',
        },
    },
};
